import { Component, vscode } from "projen";
import { TypeScriptAppProject } from "projen/lib/typescript";

/*******************************************************************************
 *
 * Configure VSCode Settings
 *
 ******************************************************************************/

export class VSCodeConfig extends Component {
  constructor(project: TypeScriptAppProject) {
    super(project);

    /**
     * Create instance of config file.
     */
    const vsConfig = new vscode.VsCode(project);

    /**
     * Add some basic configuration settings to the VS Code settings file:
     *
     * - Set the tab size to 2 spaces
     * - Enable bracket pair colorization
     * - Highlight active bracket pairs
     * - Add rulers at 80 and 120 characters
     */
    const vsSettings = new vscode.VsCodeSettings(vsConfig);
    vsSettings.addSetting("editor.tabSize", 2);
    vsSettings.addSetting("editor.detectIndentation", false);
    vsSettings.addSetting("editor.bracketPairColorization.enabled", true);
    vsSettings.addSetting("editor.guides.bracketPairs", "active");
    vsSettings.addSetting("editor.rulers", [80, 120]);

    /**
     * Add some ESLint specific settings to the VS Code settings file.
     */
    vsSettings.addSetting(
      "editor.codeActionsOnSave",
      { "source.fixAll.eslint": "explicit" },
      "typescript",
    );
  }
}
